export default __webpack_public_path__ + "static/2019_06-47a875a8aa7a64c3947772a45dd75b91.png";